module.exports = __webpack_public_path__ + "img/google-button.6bf940a.png";